import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about-us', label: 'About Reiken' },
    { path: '/portfolio', label: 'Portfolio' },
    { path: '/contact-us', label: 'Contact Us' }
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white border-b border-black/10' : 'bg-transparent'
        }`}
      >
        <div className="px-8 lg:px-20 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img
                src={isScrolled
                  ? "https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/a1c8d35e868d7f08138e4f58670a8af1.png"
                  : "https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/5f5463c4881efc978f2b332584d73b9a.png"
                }
                alt="Reiken Construction Management"
                className="h-14 w-auto"
              />
            </Link>

            <nav className="hidden md:flex items-center gap-8 lg:gap-10">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-base font-medium transition-opacity hover:opacity-60 cursor-pointer whitespace-nowrap ${
                    isScrolled ? 'text-black' : 'text-white'
                  } ${
                    location.pathname === link.path
                      ? `border-b-2 pb-1 ${isScrolled ? 'border-black' : 'border-white'}`
                      : ''
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:9174320310"
                className={`ml-4 px-5 py-2.5 text-sm font-medium border-2 transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2 ${
                  isScrolled
                    ? 'bg-black text-white border-black hover:bg-white hover:text-black'
                    : 'bg-white text-black border-white hover:bg-transparent hover:text-white'
                }`}
              >
                <i className="ri-phone-line"></i>
                917-432-0310
              </a>
            </nav>

            <button
              className="md:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span className={`w-6 h-0.5 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-black' : 'bg-white'} ${isMobileMenuOpen ? 'translate-y-2 rotate-45' : ''}`}></span>
              <span className={`h-0.5 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-black' : 'bg-white'} ${isMobileMenuOpen ? 'w-0' : 'w-6'}`}></span>
              <span className={`w-6 h-0.5 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-black' : 'bg-white'} ${isMobileMenuOpen ? '-translate-y-2 -rotate-45' : ''}`}></span>
            </button>
          </div>
        </div>
      </header>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center">
          <button
            className="absolute top-8 right-8 text-4xl cursor-pointer"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close menu"
          >
            ×
          </button>
          <nav className="flex flex-col items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-3xl font-medium hover:opacity-60 transition-opacity cursor-pointer whitespace-nowrap"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:9174320310"
              className="mt-4 px-6 py-3 bg-black text-white text-xl font-medium hover:bg-white hover:text-black border-2 border-black transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-3"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="ri-phone-line"></i>
              917-432-0310
            </a>
          </nav>
        </div>
      )}
    </>
  );
}
